import { css } from '@emotion/core';
import { applyFont, tokens } from '@domain-group/fe-brary';
import { truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  typography = tokens.typography;
export var agencyDetails = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:center;color:", colors.neutral.heavy.default, ";min-width:200px;max-width:200px;min-height:172px;border-left:1px solid ", colors.neutral.trim.default, ";");
export var platinumLogo = logoBackground => /*#__PURE__*/css("display:flex;justify-content:center;height:90px;width:100%;background-color:", logoBackground, ";");
export var goldLogo = {
  name: "ekyu9v",
  styles: "display:flex;justify-content:center;position:absolute;top:55px;"
};
export var logoContainer = {
  name: "r3j7ep",
  styles: "position:relative;left:-28px;"
};
var _ref = {
  name: "1yuhvjn",
  styles: "margin-top:16px;"
};
export var logo = isPlatinum => /*#__PURE__*/css("position:absolute;border-radius:3px;max-height:30px;max-width:95px;", isPlatinum && _ref);
export var avatarContainer = {
  name: "1f65mnf",
  styles: "display:flex;justify-content:center;position:absolute;top:54px;"
};
export var avatar = /*#__PURE__*/css("width:60px;height:60px;min-width:60px;min-height:60px;border:2px solid ", colors.neutral.surface.default, ";");
export var names = isPrivate => /*#__PURE__*/css("position:absolute;height:55px;top:", isPrivate ? '75px' : '112px', ";text-align:center;", applyFont(typography.body), " ", truncateLines(2), " color:", colors.neutral.heavy.default, ";text-decoration:none;padding:0 16px;");